import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoRfidBadgeOrderListPaidAtCell } from './emsp-bo-rfid-badge-order-list-paid-at.cell';
import { EmspBoRfidBadgeOrderListPaidAtHeader } from './emsp-bo-rfid-badge-order-list-paid-at.header';

export const EmspBoRfidBadgeOrderListPaidAtColumn: IdentifiedColumnDef<
  BackOfficeRfidBadgeOrderModel,
  BackOfficeRfidBadgeOrderModel['paidAt']
> = {
  enableSorting: false,
  header: EmspBoRfidBadgeOrderListPaidAtHeader,
  cell: EmspBoRfidBadgeOrderListPaidAtCell,
};
